import React, { useState, useEffect } from "react";
import brandIcon from "./brandIcon.png";
import info from "./infoColor.png";
import "./Recommender.css";
import {
  CloseOutlined,
  WhatsAppOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { RiWhatsappFill } from "react-icons/ri";
import { HiLink } from "react-icons/hi";
import { MdSms } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { onecodeAPI } from "../AppConfig";
import { Modal } from "antd";
import _ from "lodash";
import cv1 from "./creditcardv1.png";
import cv2 from "./creditcardv2.png";
import airplane from "./airplane.png";
import flashLight from "./flash_light.png";
import ReactPlayer from "react-player/lazy";
import { useTranslation } from "react-i18next";
import DynamicTextFormatter from "./DynamicTextFormatter";
import ApplyModal from "./ApplyModal"
import ContentModal from "../lf3/ContentModal";

let lmsRefreshIntervalId = null;
export default function LoanCardModal(props) {
  const { innerWidth: width, innerHeight: height } = window;
  const { t } = useTranslation();

  // const { customer } = props;
  const { partnerDetails, customer, customerDetails,isModalVisible, setIsModalVisible,handleCancel } = props;
  const loanCardComms = partnerDetails?.CategoryLoancard || {};

  const [tabValue, setTabValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  let sessionPartnerDetails = JSON.parse(
    sessionStorage.getItem("partnerDetails")
  );

  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [lf5Url, setLf5Url] = useState("");
  const [responseStatus, setResponseStatus] = useState(null);
  const [play, setPlay] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [lmsInternalStatus, setLmsInternalStatus] = useState(null);
  const [brandNotEligibleReasons, setBrandNotEligibleReasons] = useState([]);
  const [isEligibleModalVisible, setIsEligibleModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [emailHandlePopup, setEmailHandlePopup] = useState(false);
  const [partnerLink, setPartnerLink] = useState("");

  const [handelContentModal, setHandelContentModal] = useState(false);
  const [responsePopContent, setResponsePopContent] = useState({
    heading: "",
    description: "",
    link:""
  });


  const showModal2 = () => {
    setIsModalVisible2(true);
  };
  const handleCancel2 = () => {
    setIsModalVisible2(false);
  };
  const handleEligiblePopupCancel = () => {
    setIsEligibleModalVisible(false);
  };

  const hideEmailHandlePopup = () => {
    setEmailHandlePopup(false);
  };

  const openDetailFile = () => {
    let filePath = loanCardComms?.applyProcess?.url;
    window.open(filePath, "_blank");
  };

  const checkNavigation = (e) => {
    if (responseStatus == 409) {
      setIsModalVisible(false);
      e.preventDefault();
    }
  };

  // const onLMSBrandsClick = async () => {
  //   let hash = encodeURIComponent(searchParams.get("hash"));
  //   try {
  //     const res = await onecodeAPI.post(`/public/customer/verifyApi?`, {
  //       hash: hash,
  //       partnerId: partnerDetails?.id,
  //     });
  //     if (res.data?.data?.url) {
  //       window.open(res.data?.data?.url, "_blank");
  //     }
  //   } catch (error) {
  //     console.log(error, "error---");
  //   }
  // };

  // const checkLMSRecommendation = async () => {
  //   let hash = encodeURIComponent(searchParams.get("hash"));
  //   let recommendedBrands = [];
  //   setDataLoading(true);
  //   try {
  //     const res = await onecodeAPI.post(
  //       `/public/customer/lms/recommendations`,
  //       {
  //         hash: hash,
  //         partnerId: partnerDetails?.id,
  //       }
  //     );
  //     // recommendedBrands = _.get(res, `data.${locale}`, []);
  //     const eligibleBrands = _.get(res, `data.eligibleBrands`, []);
  //     const notEligiblePartners = _.get(res, `data.notEligiblePartners`, []);

  //     const notEligibleReasons = _.get(res, `data.message`, []);

  //     const partnerStatus = _.get(res, `data.partnerStatus`, []);
  //     const leadAddedBrands = _.map(partnerStatus,"partnerId")
  //     setBrandNotEligibleReasons(notEligibleReasons || []);
  //     let resStatus = _.get(res, "status", "");
  //     if (resStatus == 200) {
  //       let internalStatus = _.get(res, "data.status", null);
  //       setLmsInternalStatus(internalStatus);
  //       if (
  //         internalStatus == 2019 ||
  //         internalStatus == 2020 ||
  //         internalStatus == 2022
  //       ) {
  //         setDataLoading(true);
  //       }else if(internalStatus == 2028){
  //         onLMSBrandsClick();
  //       }else if(internalStatus == 2027){
  //         setEmailHandlePopup(true);
  //         setDataLoading(false);
  //       } else {
  //         setDataLoading(false);
  //         clearInterval(lmsRefreshIntervalId);
  //         const isEligibleBrand = eligibleBrands?.includes(
  //           Number(partnerDetails?.id)
  //         );
  //         if (isEligibleBrand || leadAddedBrands?.includes(partnerDetails?.id)) {
  //           applyToPartner();
  //         } else {
  //           setIsEligibleModalVisible(true);
  //           // setBrandNotEligiblePopup(true);
  //         }
  //       }

  //       // setRecommendations(rec);

  //       // setDataLoading(false);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setDataLoading(false);
  //     clearInterval(lmsRefreshIntervalId);
  //     // const errMsg = _.get(
  //     //   error,
  //     //   "response.data.message",
  //     //   "Failed to get recommendations"
  //     // );
  //     // const errStatus = _.get(
  //     //   error,
  //     //   "response.data.status",
  //     //   "Failed to get recommendations"
  //     // );
  //     // if (errStatus == 500) {
  //     //   Toaster.error("Error", errMsg);
  //     // }
  //   }
  // };

  const applyToPartner = async () => {
    let response;
    let hash = encodeURIComponent(searchParams.get("hash"));
    // console.log("partnerDetails", partnerDetails);
    let partnerId = partnerDetails?.id;

    if (partnerDetails?.shareContent?.getLink) {
      setLoading(true);
      let res = await onecodeAPI.post("/public/loanwiser/shareLink", {
        hash,
        partnerId,
      });

      let l = _.get(res, "data");
      let v = l + "&req_id=%7Bclick_id%7D";
      setLoading(false);
      // window.open(v, "_blank");
      setPartnerLink(v);
      setIsModalVisible2(true);
    } else if (partnerDetails?.leadFlow === "LF5") {
      try {
        setLoading(true);
        let resp = await onecodeAPI.post("public/customer/generateLink", {
          hash,
          partnerId,
        });
        let statusCode = _.get(resp, "data.statusCode");
        let notEligibleReasons = _.get(resp, `data.message`, []);
        let dataIssue = _.get(resp, "data.message", "");
        let editLink = _.get(resp, "data.url", "");
        setBrandNotEligibleReasons(notEligibleReasons || []);
        if (statusCode == 3307) {
          if (resp.data?.url) {
            window.open(resp?.data?.url);
          }
          return null;
        } else if (statusCode == 3308) {

          setHandelContentModal(true);
          setResponsePopContent({
            heading: "Invalid data",
            description: dataIssue ? dataIssue : "",
            link:editLink
          });
          return null;
        } else if (statusCode == 3309) {
          // setIsModalVisible(true);
          setIsEligibleModalVisible(true);
          // setBrandNotEligiblePopup(true);
          return null;
        } else if (statusCode == 3310) {
          setHandelContentModal(true);
          setResponsePopContent({
            heading: "Issue",
            description: dataIssue ? dataIssue : "",
            link:""
          });
        }
        
        if (resp?.data?.url) {
          // window.open("whatsapp://send?text=Heyy");
          setPartnerLink(resp?.data?.url);
          setIsModalVisible2(true);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error?.response?.status == 409) {
          setResponseStatus(error?.response?.status);
          setIsModalVisible2(true);
        }
        console.log(error?.response?.status);
      }
    } else {
      try {
        setLoading(true);
        response = await onecodeAPI.post(`/public/getShareLink`, {
          hash,
          partnerId,
        });
        setLoading(false);
        // window.open(response.data, "_blank");
        setPartnerLink(response.data);
        setIsModalVisible2(true);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
  };

  const whatsAppMessageTemplate = `${
    customer?.fullName
  },%0ayou can simply start your application process for ${
    partnerDetails?.title
  } by clicking the link down here.%0a${encodeURIComponent(
    lf5Url
  )}%0aNote: This is a self generated link. Do not share it with anyone.`;

  return (
    <div className="">

      <Modal
        visible={isModalVisible}
        onCancel={()=>{ 
            setPlay(false);
            handleCancel();}}
        footer={null}
        centered={true}
        closable={false}
        bodyStyle={{
          border: "1px solid  #ECEFFD",
          justifySelf: "center",
          borderRadius: "10px",
          padding: "5px",
          backgroundColor: "#ECEFFD",
          marginTop: "50px",
        }}
        width="90%"
      >
        <div>
          <div style={{ top: 35, position: "absolute", width: "100%" }}>
            <div>
              <CloseOutlined
                className="modalCloseBtn"
                onClick={handleCancel}
                style={{
                  backgroundColor: "#fff",
                  alignSelf: "flex-end",
                  padding: "5px",
                  borderRadius: "25px",
                  position: "absolute",
                  bottom: "50px",
                  right: "10px",
                }}
              />
              
            </div>
          </div>
        </div>
        <div style={{textAlign:"center"}}>
        <img
                alt=""
                // src={cv1}
                src={`https://onecode-asset.s3.ap-south-1.amazonaws.com/${partnerDetails?.id}.png`}
                style={{ width: "150px", height: "100%" }}
              />
        </div>
        <p style={{ fontWeight: "500", fontSize: "16px", textAlign: "center" }}>
          {loanCardComms?.cardName}
        </p>
        <Box
          style={{
            backgroundColor: "#fff",
            borderRadius: "5px",

            paddingBottom: 15,
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            // allowScrollButtonsMobile
            aria-label="scrollable auto tabs example"
            // sx={{
            //   "& .MuiTabScrollButton-root": {
            //     width: "25px",
            //   },
            // }}
            style={{ marginLeft: 15, marginRight: 15 }}
          >
            <Tab
              label="FEATURES"
              sx={{
                paddingLeft: "3px",
                paddingRight: "5px",
                paddingTop: "8px",
                paddingBottom: "0px",
                minWidth: "50px",
              }}
            />
            <Tab
              label="DOCUMENTS"
              sx={{
                paddingLeft: "3px",
                paddingRight: "5px",
                paddingTop: "8px",
                paddingBottom: "0px",
                minWidth: "50px",
              }}
            />
            <Tab
              label="APPLY PROCESS"
              sx={{
                paddingLeft: "3px",
                paddingRight: "5px",
                paddingTop: "8px",
                paddingBottom: "0px",
                minWidth: "50px",
              }}
            />
            <Tab
              label="T&C"
              sx={{
                paddingLeft: "3px",
                paddingRight: "5px",
                paddingTop: "8px",
                paddingBottom: "0px",
                minWidth: "50px",
              }}
            />
          </Tabs>
          <div
            style={{
              height: height ? `${(height / 100) * 60}px` : "300px",
              overflow: "scroll",
              paddingTop: "10px",
              paddingLeft: 15,
              paddingRight: 15,
            }}
          >
            {tabValue == 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                        <div
                          style={{ paddingLeft: "5px", paddingBottom: "10px" }}
                        >
                          {loanCardComms.features &&
                            loanCardComms.features.map((subText) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <span>{`⚡`}</span>
                                  <span
                                    style={{
                                      color: "#696969",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    {`${subText}`}
                                  </span>
                                </div>
                              );
                            })}
                        </div>
              </div>
            ) : null}
            {tabValue == 1 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                        <div style={{ paddingLeft: "5px" }}>
                          <ul style={{ paddingLeft: "15px" }}>
                            {loanCardComms?.documentsRequired &&
                              loanCardComms?.documentsRequired.map((subText) => {
                                return (
                                  <li>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <span style={{ color: "#696969" }}>
                                        {subText}
                                      </span>
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
              </div>
            ) : null}
            {tabValue == 2 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                {loanCardComms?.applyProcess?.fileType == "pdf" ? (
                  <>
                    <div
                      onClick={() => {
                        openDetailFile();
                      }}
                      style={{ position: "relative" }}
                    >
                      <img
                        alt=""
                        src={loanCardComms?.applyProcess?.thumbnailUrl}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "contain",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: "8px",
                          right: "0px",
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                          color: "rgb(108, 99, 255)",
                        }}
                      >
                        View
                      </div>
                    </div>
                  </>
                ) : null}

                {loanCardComms?.applyProcess?.fileType == "video" ? (
                  <ReactPlayer
                    url={`https://www.youtube.com/watch?v=${loanCardComms?.applyProcess?.url}`}
                    controls={true}
                    playing={play}
                    width="100%"
                    className="react-player"
                    height={200}
                    style={{ marginTop: 20 }}
                    light={loanCardComms?.applyProcess?.thumbnailUrl}
                    onPlay={() => {
                      setPlay(true);
                    }}
                  />
                ) : null}
              </div>
            ) : null}
            {tabValue == 3 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                {loanCardComms?.customerTNC &&
                  loanCardComms?.customerTNC.map((tc) => {
                    return (
                      <>
                        <div
                          className="CCCardSamllCard"
                          style={{
                            padding: "2px",
                            paddingLeft: "0px",
                            paddingRight: "5px",
                            fontWeight: "bold",
                          }}
                        >
                          <span>{tc.heading}</span>
                        </div>
                        <div style={{ paddingLeft: "5px" }}>
                          <ul style={{ paddingLeft: "15px" }}>
                            {tc.subText &&
                              tc.subText.map((subText) => {
                                return (
                                  <li>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <span style={{ color: "#696969" }}>
                                        {subText}
                                      </span>
                                    </div>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </>
                    );
                  })}
              </div>
            ) : null}
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              onClick={() => {
                handleCancel();
                // if (
                //   (!customerDetails?.email ||
                //     !customerDetails?.employerName ||
                //     !customerDetails?.workExperience) &&
                //   partnerDetails.isLMSFlow
                // ) {
                //   onLMSBrandsClick();
                // } else if (partnerDetails.isLMSFlow) {
                //   checkLMSRecommendation();
                // } else {
                  applyToPartner();
                // }
                // showModal();
                window?.Moengage?.track_event("add-customer_customer_apply", {
                  customer_name: customer?.fullName,
                  customer_phonenumber: customer?.phoneNumber,
                  brand_name: partnerDetails?.title,
                  brand_category: partnerDetails?.subCategory,
                });
              }}
              style={{
                width: "90%",
                fontWeight: "500",
                backgroundColor: "#6C63FF",
                border: "none",
                fontSize: "14px",
                borderRadius: "5px",
                color: "#FFFFFF",
                padding: "5px",
              }}
            >
              Apply
              {(dataLoading || loading) && (
              <LoadingOutlined size={"small"} style={{ marginLeft: 10 }} />
            )}
            </button>
          </div>
        </Box>
      </Modal>
      <ApplyModal
          isModalVisible={isModalVisible2}
          handleCancel={handleCancel2}
          responseStatus={responseStatus}
          partnerDetails={partnerDetails}
          setIsModalVisible={setIsModalVisible}
          customer={customerDetails}
          link={lf5Url}
          buttonToDisplay={partnerDetails?.attributionType == "WEB" ? "continue" : "whatsapp"}
          partnerLink={partnerLink}
        />
      {/* <Modal
        visible={isModalVisible2}
        onCancel={handleCancel2}
        footer={null}
        centered={true}
        closable={true}
        bodyStyle={{
          border: "1px solid  #fff",
          justifySelf: "center",
          borderRadius: "10px",
          padding: "20px",
        }}
        width="90%"
        closeIcon={<CloseOutlined className="modalCloseBtn" />}
      >
        <p
          style={{
            textAlign: "center",
            fontSize: "15px",
            color: "#7D7D7D",
          }}
        >
          {responseStatus == 409 ? (
            <DynamicTextFormatter
              textString={t("recommendation.AlreadyApplied")}
              values={{
                __PartnerTitle__: { value: partnerDetails?.title },
              }}
            />
          ) : (
            <>
              <p></p>
            </>
          )}
        </p>

        {responseStatus !== 409 && (
          <div
            style={{
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <button
              onClick={() => {
                if (responseStatus == 409) {
                  setIsModalVisible2(false);
                } else {
                  window.open(
                    `whatsapp://send?text=${whatsAppMessageTemplate}&phone=+91${customer?.phoneNumber}`
                  );
                }
              }}
              style={{
                background: "#00c34e",
                borderRadius: "5px",
                // width: "40%",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                padding: "0.5rem",
                paddingLeft: "0.9rem",
                paddingRight: "0.9rem",
              }}
            >
              <p
                style={{
                  color: "#6C63FF",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 0,
                  padding: 0,
                }}
              >
                {responseStatus == 409 ? (
                  "Ok"
                ) : (
                  <>
                    <RiWhatsappFill
                      style={{
                        color: "#FFF",
                        // color: "#25D366",
                        fontSize: "15px",
                      }}
                    />
                    <p
                      style={{
                        color: "#FFF",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        marginBottom: 0,
                        padding: 0,
                        marginLeft: "5px",
                      }}
                    >
                      Generate Link
                    </p>
                  </>
                )}
              </p>
            </button>
          </div>
        )}
      </Modal> */}

      {isEligibleModalVisible && (
        <Modal
          visible={isEligibleModalVisible}
          onCancel={handleEligiblePopupCancel}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
              fontWeight: "bold",
            }}
          >
            Not Eligible
          </p>
          {brandNotEligibleReasons?.map((item, key) => (
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
              }}
            >
              {key + 1}. {item}
            </p>
          ))}
        </Modal>
      )}
      {emailHandlePopup && (
        <Modal
          visible={emailHandlePopup}
          onCancel={hideEmailHandlePopup}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
              fontWeight: "bold",
            }}
          >
            Invalid Email ID!
          </p>
          
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
              }}
            >
              Email already exists OR invalid characters/length/domain in Email, please ask your Business Consultant to update the email ID and apply again.
            </p>
            <div style={{ textAlign: "center" }}>
            <button
              onClick={() => {
                hideEmailHandlePopup();
              }}
              style={{
                width: "90%",
                fontWeight: "500",
                backgroundColor: "#6C63FF",
                border: "none",
                fontSize: "14px",
                borderRadius: "5px",
                color: "#FFFFFF",
                padding: "5px",
              }}
            >
              Ok, got it.
            </button>
          </div>
        </Modal>
      )}
      {handelContentModal && (
          <ContentModal
            modalVisible={handelContentModal}
            popupContent={responsePopContent}
            setHandelContentModal={setHandelContentModal}
            // popupContent={"suupppp"}
          />
        )}
    </div>
  );
}
